import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';
import { Router , Routes, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { NetworkListing }  from './networks/listing/network-listing.component';
import NetworkingView  from './networking-view.component';
import AddEditNetworkDialog  from
    './networks/dialogs/add-edit-network-dialog.component';
import AddEditImportNetworkDialog  from
    './networks/import-network/add-edit-import-network-dialog.component';
import AddEditInterfaceDialog from
    './gateways/dialogs/add-edit-interface-dialog.component';
import AddEditGatewayWizard from './gateways/dialogs/add-edit-gateway-wizard.component';
import IPScope  from './networks/dialogs/ipscope-component';
import GatewayDescribeStep from './gateways/dialogs/wizard-steps/gateway-describe-step.component';
import GatewayCLISettings from './gateways/dialogs/wizard-steps/gateway-cli-settings.component';
import GatewayDeploymentConfigurations from
    './gateways/dialogs/wizard-steps/gateway-deployment-configuration.component';
import GatewayInterfaceConfiguration from
    './gateways/dialogs/wizard-steps/gateway-interface-configuration.component';
import GatewayDefaultSettings from
    './gateways/dialogs/wizard-steps/gateway-default-settings.component';
import { GatewayListing } from './gateways/listing/gateway-listing.component';
import  { AssociateVcDialog }  from './networks/import-network/associate-vc-dialog-component';
import { ImportGatewayDialog }  from  './gateways/dialogs/import-gateway/import-gateway-dialog.component';


@NgModule({
    declarations: [
        NetworkListing,
        NetworkingView,
        AddEditNetworkDialog,
        AddEditImportNetworkDialog,
        ImportGatewayDialog,
        GatewayListing,
        IPScope,
        AddEditGatewayWizard,
        GatewayDescribeStep,
        GatewayCLISettings,
        GatewayDeploymentConfigurations,
        GatewayInterfaceConfiguration,
        AddEditInterfaceDialog,
        GatewayDefaultSettings,
        AssociateVcDialog
    ],
    exports: [
        NetworkListing,
        NetworkingView,
        AddEditNetworkDialog,
        AddEditImportNetworkDialog,
        ImportGatewayDialog,
        IPScope,
        GatewayListing,
        AddEditGatewayWizard,
        GatewayDescribeStep,
        GatewayCLISettings,
        GatewayDeploymentConfigurations,
        GatewayInterfaceConfiguration,
        AddEditInterfaceDialog,
        GatewayDefaultSettings,
        AssociateVcDialog
    ],
    imports: [
        BrowserModule,
        TranslateModule,
        ClarityModule.forRoot(),
        VcaCommonModule,
        RouterModule,
        FormsModule
    ]
})

export class NetworkingModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networking.module.ts